export default __webpack_public_path__ + "static/media/Icons_Warning Icon.7333d9cf.svg";